/**
 * Получение информации об устройстве
 * @packageDocumentation
 */

/**
 * Определить, увеличинная ли плотность пикселей у экрана (DPR > 1)
 */
export function isRetina(): boolean {
	return ('devicePixelRatio' in window && window.devicePixelRatio > 1);
}

/**
 * Определить, является ли устройство мобильным
 */
export function isMobile(): boolean {
	return !!navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|IEMobile|Opera Mini/i);
}

/**
 * Определить, открыт ли сайт в приложении
 */
export function isApp(): boolean {
	return (navigator.userAgent.indexOf('Topvisor_App') != -1);
}

/**
 * Определить, является ли OS пользователя macOS
 */
export function isMacOS(): boolean {
	return navigator.userAgent.indexOf('Mac OS X') !== -1;
}

/**
 * Определить, является ли текущий браузер пользователя Safari
 */
export function isSafari(): boolean {
	const isChrome = /Chrome|Android/.test(navigator.userAgent);

	let isSafari = /Safari/.test(navigator.userAgent);
	if (isChrome && isSafari) {
		isSafari = false;
	}

	return isSafari;
}

/**
 * Вернуть текст для обозначения клавиши Ctrl / Command в зависимости от OS
 */
export function getCommandKeyLabel(): 'Ctrl' | '⌘' {
	if (isMacOS()) {
		return '⌘';
	} else {
		return 'Ctrl';
	}
}

/**
 * Вернуть скролл с учетом устройства
 */
export const getScrollTop = (): number | undefined => {
	return $(document).scrollTop();
};

/**
 * Вернуть контейнеры со скроллом (требует jquery)
 */
export const get$scroll = (): JQuery<Document> => {
	return $(document);
};

/**
 * Вернуть контейнеры со скроллом (без jquery)
 */
export const getElsScroll = (): Document[] => {
	return [document];
};

/**
 * Получить операционную систему пользователя
 *
 * Не определяет Windows 11, см. getOSAsync()
 */
export const getOS = (): string => {
	const os: [string, RegExp][] = [
		['iOS', /(iPhone|iPad)/i],
		['Android', /(Android)/i],
		['Windows Phone', /(IEMobile)/i],
		['Windows 3.11', /Win16/i],
		['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/i],
		['Windows 98', /(Windows 98)|(Win98)/i],
		['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/i],
		['Windows XP', /(Windows NT 5.1)|(Windows XP)/i],
		['Windows Server 2003', /(Windows NT 5.2)/i],
		['Windows Vista', /(Windows NT 6.0)/i],
		['Windows 7', /(Windows NT 6.1)/i],
		['Windows 8', /(Windows NT 6.[23])|(Windows 8)/i],
		['Windows 10', /(Windows NT 10)/i],
		['Windows NT 4.0', /(Windows NT 4.0)|(WinNT4.0)|(WinNT)|(Windows NT)/i],
		['Windows ME', /Windows ME/i],
		['Windows', /Windows/i],
		['Open BSD', /OpenBSD/i],
		['Sun OS', /SunOS/i],
		['Linux', /(Linux)|(X11)/i],
		['Macintosh', /(Mac_PowerPC)|(Macintosh)|(Mac OS X 10.4)|(Mac OS X 10.5)|(Mac OS X 10.6)/i],
		['QNX', /QNX/i],
		['BeOS', /BeOS/i],
		['OS/2', /OS\/2/i],
	];

	let res = '';
	for (let i = 0; i < os.length; i++) {
		if (os[i][1].test(navigator.userAgent)) {
			res = os[i][0];

			break;
		}
	}

	return res;
};

/**
 * Получить операционную систему пользователя, в том числе Windows 11
 */
export const getOSAsync = async (): Promise<string> => {
	let os = getOS();

	if (os === 'Windows 10') {
		// @ts-ignore - experimental technology
		const platformVersion = await navigator?.userAgentData?.getHighEntropyValues(['platformVersion']);
		if (platformVersion && platformVersion.platformVersion >= '13') {
			os = 'Windows 11';
		}
	}

	return os;
};
